<template>
  <pf-grid-item xl="3" v-bind="ouiaProps" style="min-width: 280px">
    <template v-if="name">{{ name }}: </template>
    <slot
      ><strong>{{ value }}</strong></slot
    >
    <pf-button v-if="editStep" variant="link" @click="goToStep(editStep)" inline small>
      <template #icon><edit-icon /></template>
    </pf-button>
  </pf-grid-item>
</template>

<style scoped>
:deep(.pf-v6-c-button.pf-m-link) {
  padding: 0 0 0 5px;
}
</style>

<script lang="ts" setup>
import EditIcon from '@vue-patternfly/icons/edit-alt-icon';
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizard } from '@/wizard';

const props = defineProps<
  OUIAProps & {
    name?: string;
    value?: string;
    editStep?: string;
  }
>();
const ouiaProps = useOUIAProps(props);

const wizard = useWizard();

function goToStep(step: string) {
  wizard.currentStep = step;
}
</script>
